import React from 'react';
import { useTranslation } from 'react-i18next';

export interface LoginInfoSectionProps {
  email: string;
  onChangePassword: () => void;
}

const LoginInfoSection: React.FC<LoginInfoSectionProps> = ({
  email,
  onChangePassword,
}) => {
  const { t } = useTranslation('profile');

  return (
    <div className="space-y-5">
      <h3 className="text-lg font-semibold text-gray-800">
        {t('myProfile.form.loginInfo')}
      </h3>

      {/* Email (read-only) */}
      <div>
        <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
          {t('myProfile.form.email')}
        </label>
        <input
          id="email"
          type="email"
          value={email}
          readOnly
          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg bg-gray-50 text-gray-500 cursor-not-allowed focus:outline-none"
        />
      </div>

      {/* Change Password */}
      <div>
        <button
          type="button"
          onClick={onChangePassword}
          className="px-4 py-2 text-sm font-medium text-blue-600 border border-blue-600 rounded-lg hover:bg-blue-50 focus:ring-1 focus:ring-blue-500 focus:outline-none transition-colors"
        >
          {t('myProfile.form.changePassword')}
        </button>
      </div>
    </div>
  );
};

export default LoginInfoSection;
